export const GRAY_100 = '#F8F9FA';
export const GRAY_200 = '#E9EBEF';
export const GRAY_300 = '#D1D3DB';
export const GRAY_400 = '#CED2DA';
export const GRAY_500 = '#AEAFBD';
export const GRAY_600 = '#6A6E7A';
export const GRAY_700 = '#494E57';
export const GRAY_800 = '#42454B';
export const GRAY_900 = '#121212';
export const WHITE = '#FFFFFF';
export const RED = '#FB2F3C';
export const YELLOW_200 = '#FFC453';
export const BLUE_200 = '#4E81E3';
export const GREEN_200 = '#3CB78B';
export const PURPLE_100 = '#C3B2FF';
export const PURPLE_300 = '#5335B4';
export const PINK = '#FFD7D5';
export const CREAM = '#F9F1E1';
export const BRAND_PRIMARY = '#A578FF';
export const BRAND_SECONDARY = GRAY_600;
export const BRAND_INFO = '#4199E1';
export const BRAND_SUCCESS = YELLOW_200;
export const BRAND_WARNING = YELLOW_200;
export const BRAND_DANGER = RED;
